import Vue from 'vue'
import App from './App'
import './assets/normalize.css'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router/router'
import store from './store'
import RightToolbar from "@/components/RightToolbar"
import TabView from "@/components/TabView"
import axios from 'axios'
import moment from 'moment'
import Distpicker from 'v-distpicker'
import 'swiper/dist/css/swiper.css'
import './assets/icons/iconfont.css'
import './assets/styles/transition.css'
import 'babel-polyfill'
import 'default-passive-events'
import util from './common/util.js'
import * as echarts from 'echarts';
import PuzzleVerification from 'vue-puzzle-verification'//拼图滑块
Vue.prototype.$echarts = echarts;
Vue.component('v-distpicker', Distpicker)
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.prototype.util = util
Vue.use(Element)
Vue.component('RightToolbar', RightToolbar)
Vue.component("TabView", TabView);
Vue.use(PuzzleVerification)  //拼图滑块
// 中文简体
moment.locale('zh-cn');
Vue.filter('dateformat', (dataStr, pattern = 'YYYY-MM-DD') => {
  if (dataStr) {
    return moment(dataStr).format(pattern)
  }
})
Vue.filter('timeformat', (timestamp) => {
  if (timestamp) {
    var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = (date.getDate() < 10 ? '0' + date.getDate()  : date.getDate())+' ' ;
    var h = (date.getHours() < 10 ? '0' + date.getHours()  : date.getHours())+':' ;
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes()  : date.getMinutes())+':' ;
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds()  : date.getSeconds() ;
    return Y + M + D + h + m + s;
  }
})
Vue.filter('getDateFormat', (date) => {
  if (date) {
    var dateee = new Date(date).toJSON();
    return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  }
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
  // var sysType = to.meta.sysType
  // // 判断该路由是否需要登录权限
  // if (sysType == 'login') {
  //   next('/system')
  // } else {
  //   next()  // 确保一定要有next()被调用
  // }
})
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js